import { useEffect, useState } from 'react';
import useCallApiAndLoad from './useCallApiAndLoad';
import useAuth from './useAuth';
import { getProjectListEndpoint } from '../pages/withdrawal/services/projectService';
import { fetchResponseAdapter } from '../adapters/fetchAdapter';

interface Project {
  id: string;
  name: string;
}

interface UseProjectListResult {
  projects: Project[];
  isLoading: boolean;
  error: string | null;
}

const useProjectList = (): UseProjectListResult => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();

  const loadProject = async () => {
    setIsLoading(true);
    try {
      const { status, data } = await callEndpoint(
        getProjectListEndpoint(token),
      );
      if (status === 200) {
        const projectsResponse = fetchResponseAdapter(data);
        setProjects(projectsResponse.data);
      } else {
        setError('error loading projects');
        setProjects([]);
      }
    } catch (e) {
      setError('error loading projects');
      setProjects([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadProject();
  }, []);

  return {
    projects,
    isLoading,
    error,
  };
};

export default useProjectList;
